module.exports = __webpack_public_path__ + "696de1ce.svg";